import type { ReactNode } from "react";
import { Form } from "@circle-react-uikit/Form";
import type { ItemProps } from "@circle-react-uikit/Form/Item";

interface FormItemProps extends ItemProps {
  children?: ReactNode;
}

export const FormItem = (props: FormItemProps) => (
  <Form.Item
    hideDescription
    hideBorder
    fullWidth
    translationRoot="help_widget.send_message_form"
    {...props}
  />
);
